import { createSelector } from "reselect";

const getRfqState = (state) => state.shopping.rfq;

export const getRfqPositions = createSelector(getRfqState, (state) => state.positions);
export const getRfqPositionCount = createSelector(getRfqPositions, (positions) => positions.length);
export const getRfqPositionPriceSum = createSelector(getRfqState, (state) => state.positionPriceSum);
export const getRfqCurrency = createSelector(getRfqState, (state) => state.currency);
export const getRfqId = createSelector(getRfqState, (state) => state.id);

export const getRfqGoodsRecipientIsCustomer = createSelector(getRfqState, (state) => state.goodsRecipientIsCustomer);
export const getRfqGoodsRecipient = createSelector(getRfqState, (state) => state.goodsRecipient);
export const getRfqCustomer = createSelector(getRfqState, (state) => state.customer);

export const getRfqComment = createSelector(getRfqState, (state) => state.comment);
export const getRfqReferenceNumber = createSelector(getRfqState, (state) => state.referenceNumber);
export const getRfqNumber = createSelector(getRfqState, (state) => state.rfqNumber);
export const getRfqTicketNumber = createSelector(getRfqState, (state) => state.ticketNumber);

export const getRfqSubmitDate = createSelector(getRfqState, (state) => state.submitDate);
export const getRfqCreateDate = createSelector(getRfqState, (state) => state.createDate);
export const getRfqUpdateDate = createSelector(getRfqState, (state) => state.updateDate);

export const getRfqStatus = createSelector(getRfqState, (state) => state.status);
export const getRfqStatusInfo = createSelector(getRfqState, (state) => state.statusInfo);

// meta
export const getIsRfqSyncing = createSelector(getRfqState, (state) => state.isSyncing);
export const getHasFetchError = createSelector(getRfqState, (state) => state.hasFetchError);
